module.exports = __webpack_public_path__ + "static/media/ei05.f5c03c87.png";